import { useThemeObserver } from '@atlaskit/tokens';
import { ConfluenceBannerFirstPartyRecommendation } from '@post-office/components--confluence-banner-first-party-recommendation';
import { FormattedMessage, useIntl } from 'react-intl-next';

import { createRender } from './types';
import { PRODUCT_LOGO_JSM_DARK } from '../../../assets/product-logo-jsm-dark';
import { PRODUCT_LOGO_JSM_LIGHT } from '../../../assets/product-logo-jsm-light';

const jsmLogoByTheme = (colorMode: 'light' | 'dark') => {
	return colorMode === 'light' ? <PRODUCT_LOGO_JSM_LIGHT /> : <PRODUCT_LOGO_JSM_DARK />;
};

export const render = createRender(({ onDismissed }) => {
	const intl = useIntl();
	const { colorMode } = useThemeObserver();

	return (
		<ConfluenceBannerFirstPartyRecommendation
			app={{
				hamsIdentifier: 'jira-servicedesk.ondemand',
				ccpProductId: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
				logo: (
					<span
						role="img"
						aria-label={intl.formatMessage({
							id: 'post-office.growth.recommendation-jsm.confluence-home-banner.logo-alt-text',
							description:
								'Alt text for the product logo in Jira Service Management recommendation message in Confluence Home Banner',
							defaultMessage: 'Jira Service Management Product Logo',
						})}
					>
						{jsmLogoByTheme(colorMode || 'light')}
					</span>
				),
				header: (
					<FormattedMessage
						id="post-office.growth.recommendation-jsm.confluence-home-banner.header"
						description="Header for Jira Service Management recommendation message in Confluence Home Banner"
						defaultMessage="See the whole picture, from request to resolution"
					/>
				),
				description: (
					<FormattedMessage
						id="post-office.growth.recommendation-jsm.confluence-home-banner.description"
						description="Description for Jira Service Management recommendation message in Confluence Home Banner"
						defaultMessage="Automatically turn Slack, Teams, and email requests into tickets."
					/>
				),
			}}
			onDismissed={onDismissed}
		/>
	);
});

export default render;
